import React from 'react'
import { CardTitle } from 'material-ui/Card'
import RaisedButton from 'material-ui/RaisedButton'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import CircularProgress from 'material-ui/CircularProgress'
import get from 'lodash/get'

import Spacer from '../spacer'
import FileInput from '../file-input'
import api from '../../api'

class FSPGroupSort extends React.Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      file: null,
      result: null,
      submitting: false
    }
  }

  handleFileSelection = file => {
    this.setState({ file })
  }

  handleSubmit = () => {
    const { file } = this.state
    const formData = new window.FormData()
    formData.append('file', file, file.name)

    this.setState({ submitting: true })

    api.postFile('admin/fsp_group_sort', { body: formData })
      .then(res => res.json())
      .then(data => {
        this.setState({
          file: null,
          result: data,
          submitting: false
        })
      })
      .catch(() => {
        this.setState({ submitting: false })
      })
  }

  closeDialog = () => {
    this.setState({
      result: null
    })
  }

  render () {
    const { file, result, submitting } = this.state

    return (
      <div>
        <CardTitle title='FSP Group Pre-Sort' style={{ paddingLeft: 0 }} />
        <p>
          Upload an FSP intake survey CSV. The system will perform an initial
          pre-sort on this data, providing a CSV with a potential starting point
          for small groups for the FSP.
        </p>
        <FileInput
          accept='text/csv'
          label='Select CSV'
          onFileSelected={this.handleFileSelection}
        />
        <span style={{ paddingLeft: '15px' }}>{get(file, 'name')}</span>
        {
          file &&
            <div>
              <Spacer />
              <RaisedButton
                label='Submit'
                labelPosition='before'
                primary
                onClick={this.handleSubmit}
                icon={submitting ? <CircularProgress size={20} thickness={2} /> : null}
              />
            </div>
        }
        {
          result &&
            <Dialog
              title='Download CSV'
              modal={false}
              open
              actions={[
                <FlatButton
                  label='Close'
                  primary
                  onClick={this.closeDialog}
                />
              ]}
              onRequestClose={this.closeDialog}
            >
              <a href={result.url}>
                {result.filename}
              </a>
            </Dialog>
        }
      </div>
    )
  }
}

export default FSPGroupSort
